import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/useAuth";
import "./Specs.css";
import { SpecsModel } from "../../Models/SpecsModel";

import specsImage from "../../Assets/specs.png";
import { Table } from "react-bootstrap";


interface Props {
    specsModel: SpecsModel;
}

const SpecsSection = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();
 return (
    <div className="container mt-5">
        <div className="card shadow-sm p-4">
                <div className="row align-items-center">
                    <div className="col-md-12">
                        <img
                        src={specsImage} className="hero-image p-0 img-fluid rounded"
                        alt="Part"
                        />
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-12">
                        <h3>Geometry</h3>
                    </div>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                        <th>Measurement</th>
                        <th>XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Stack (A)</td>
                            <td>{ props.specsModel.stack }cm</td>
                        </tr>
                        <tr>
                            <td>Reach (B)</td>
                            <td>{ props.specsModel.reach }cm</td>
                        </tr>
                        <tr>
                            <td>Head Tube Angle (C)</td>
                            <td>{ props.specsModel.head_tube_angle }°</td>
                        </tr>
                        <tr>
                            <td>Head Tube Length (D)</td>
                            <td>{ props.specsModel.head_tube_length }cm</td>
                        </tr>
                        <tr>
                            <td>Seat Tube Angle (E)</td>
                            <td>{ props.specsModel.seat_tube_angle }°</td>
                        </tr>
                        <tr>
                            <td>Seat Tube Length (F)</td>
                            <td>{ props.specsModel.seat_tube_length }cm</td>
                        </tr>
                        <tr>
                            <td>Top Tube Effective (G)</td>
                            <td>{ props.specsModel.top_tube_effective }cm</td>
                        </tr>
                        <tr>
                            <td>Bottom Bracket Height (H)</td>
                            <td>{ props.specsModel.bb_height }cm</td>
                        </tr>
                        <tr>
                            <td>Bottom Bracket Drop (I)</td>
                            <td>{ props.specsModel.bb_drop }cm</td>
                        </tr>
                        <tr>
                            <td>Chainstay (J)</td>
                            <td>{ props.specsModel.chainstay }cm</td>
                        </tr>
                        <tr>
                            <td>Wheel Base (K)</td>
                            <td>{ props.specsModel.wheel_base }cm</td>
                        </tr>
                        <tr>
                            <td>Standover Height (L)</td>
                            <td>{ props.specsModel.stadover_height }cm</td>
                        </tr>
                        <tr>
                            <td>Handle Bar Width</td>
                            <td>{ props.specsModel.handle_bar_width }cm</td>
                        </tr>
                        <tr>
                            <td>Stem Length</td>
                            <td>{ props.specsModel.stem_length }cm</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
    </div>
  );
}

export default SpecsSection;
